import ListProcesses from "@/views/agro_exporter/quality_reports/container_provider/ListProcesses.vue";
import ShowProcess from "@/views/agro_exporter/quality_reports/container_provider/ShowProcess.vue";
import ShowProcessSummary from "@/components/views/agro_exporter/quality_reports/container_provider/show_process/Summary.vue";
import ShowProcessGraphics from "@/components/views/agro_exporter/quality_reports/container_provider/show_process/Graphics.vue";
import ShowProcessData from "@/components/views/agro_exporter/quality_reports/container_provider/show_process/Data.vue";
import QuarterlyAnalysis from "@/components/views/agro_exporter/quality_reports/container_provider/show_process/QuarterlyAnalysis.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "quality_reports",
  permission: "container_provider",
});


export default [
  {
    path: "/ae/:agro_exporter_id/quality_reports/container_provider/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/container_provider/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/container_provider/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    props: true,
    meta: META,
    redirect: { name: routeName("show_process_graphics") },
    children: [
    {
        path: "summary",
        name: routeName("show_process_summary"),
        alias: "",
        component: ShowProcessSummary,
        props: true
      },
      {
        path: "graphics",
        name: routeName("show_process_graphics"),
        alias: "",
        component: ShowProcessGraphics,
        props: true
      },
      {
        path: "data",
        name: routeName("show_process_data"),
        component: ShowProcessData,
        props: true
      },
      {
        path: "quarterly-analysis",
        name: routeName("show_process_quarterly_analysis"),
        component: QuarterlyAnalysis,
        props: true
      },
    ],
  },
];
